import { useCallback, useState } from "react";
import { gridToDbRows } from "./convert";
import { Button, message } from "antd";
import { parseError, WORKBOOK_ROLES } from "../../../utils/shared";
import httpClient from "../../../api/httpClient";

const Toolbar = ({
  spreadSheetData,
  data,
  copySelection,
  setSpreadSheetData,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const saveChanges = useCallback(async () => {
    try {
      setSubmitting(true);

      const { rows, updatedRows } = gridToDbRows(spreadSheetData?.rows, data);

      if (!rows.length) {
        message.info("No changes to save");
        return;
      }

      await httpClient.post("spreadsheet", {
        rows,
        spreadsheet_id: spreadSheetData?.id,
        workbook_id: spreadSheetData?.workbook_id,
      });

      setSpreadSheetData({
        ...spreadSheetData,
        rows: updatedRows,
      });

      message.success("Saved successfully!");
    } catch (error) {
      parseError(error, true);
    } finally {
      setSubmitting(false);
    }
  }, [spreadSheetData, data]);
  return (
    <>
      <div className="xg-toolbar-sep" />
      <Button className="xg-btn" onClick={copySelection}>
        ⎘ Copy
      </Button>
      {[WORKBOOK_ROLES.OWNER, WORKBOOK_ROLES.EDITOR].includes(
        spreadSheetData?.role,
      ) && (
        <Button
          type="primary"
          className="save-btn"
          onClick={saveChanges}
          disabled={submitting}
          loading={submitting}
        >
          💾 Save Data
        </Button>
      )}
    </>
  );
};
export default Toolbar;
